import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="role-prices"
export default class extends Controller {
  static targets = [
    "basicBasePriceEUR",
    "basicBasePriceCZK",
    "premiumBasePriceEUR",
    "premiumBasePriceCZK",
    "vipBasePriceEUR",
    "vipBasePriceCZK",
    "eliteBasePriceEUR",
    "eliteBasePriceCZK",

    "basicSalePriceEUR",
    "basicSalePriceCZK",
    "premiumSalePriceEUR",
    "premiumSalePriceCZK",
    "vipSalePriceEUR",
    "vipSalePriceCZK",
    "eliteSalePriceEUR",
    "eliteSalePriceCZK",

    "basicBulkPriceEUR",
    "basicBulkPriceCZK",
    "premiumBulkPriceEUR",
    "premiumBulkPriceCZK",
    "vipBulkPriceEUR",
    "vipBulkPriceCZK",
    "eliteBulkPriceEUR",
    "eliteBulkPriceCZK",

    "basicRoundedCornerPriceEUR",
    "basicRoundedCornerPriceCZK",
    "premiumRoundedCornerPriceEUR",
    "premiumRoundedCornerPriceCZK",
    "vipRoundedCornerPriceEUR",
    "vipRoundedCornerPriceCZK",
    "eliteRoundedCornerPriceEUR",
    "eliteRoundedCornerPriceCZK",
  ];

  connect() {
    console.info("Role prices connected.");
  }
}
